import { useState, useRef, useEffect } from "react";
import styled from "styled-components";
import { TextControl } from "../generic/Core";

import { Form } from '../form/FormComponents';
import { CountryFlag } from "./CountryMenuItem";
import CountryModal_m from "./CountryModal_m";

import useTranslation from "../../hooks/useTranslation";
import useKeyPress from "../../hooks/useKeyPress";


const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const InputField = styled(TextControl)`
    padding-left: 50px;
`;

const InputFlag = styled(CountryFlag)`
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  z-index: 2;
`

const InputIcon = styled.div`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%) rotate(90deg);
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 8px 10px 8px;
  border-color: transparent transparent ${({ theme }) => theme.font.color} transparent;
`;

const InputWithIcon = ({ showModal, placeholder, value, valueId, name = 'country', isRed, flags, testId }) => {
    const enterPressed = useKeyPress('Enter')

    useEffect(() => {
        const focusedElem = document.activeElement;
        if (enterPressed && focusedElem.name === 'countryName') {
            showModal()
        }
    }, [enterPressed]);

    return (
        <InputWrapper>
            <InputFlag src={flags[valueId]}></InputFlag>
            <InputField
                onClick={showModal}
                name={name}
                value={value}
                placeholder={placeholder}
                autoComplete="off"
                readOnly
                {...(isRed && { required: true })}
                data-testid={`${testId}.m`}
            />
            {!isRed && <InputIcon />}
        </InputWrapper>
    );
};

const SearchContainer = styled.div`
    height: "100%";

    @media (min-width: ${({ theme }) => theme.breakpoint.xs}) {
        display: none;
    }
`


const CountryControl_m = ({ data, onSelect, placeholder, valueId, valueName, isRed, flags, testId, name = 'country' }) => {
    const [isVisible, setIsVisible] = useState(false);
    const searchContainer = useRef(null);
    const { t } = useTranslation()

    const showModal = () => setIsVisible(true);
    const hideModal = () => setIsVisible(false);

    return (
        <SearchContainer ref={searchContainer}>
            <Form.Group name="Country">
                <InputWithIcon
                    value={valueName || ''}
                    valueId={valueId}
                    name={name}
                    showModal={showModal}
                    placeholder={t(placeholder)}
                    isRed={isRed}
                    flags={flags}
                    testId={testId}
                />
            </Form.Group>
            {isVisible && (
                <CountryModal_m
                    isVisible={isVisible}
                    setIsVisible={setIsVisible}
                    data={data}
                    valueName={valueName}
                    onSelect={onSelect}
                    flags={flags}
                />
            )}
        </SearchContainer>
    );
};

export default CountryControl_m;
